// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-header__icon{color:#6369bb}.main-header__icon.main-header__icon--large{max-width:1070px}@media(max-width:767px){.main-header__icon.main-header__icon--large{display:none}}.main-header__icon.main-header__icon--small{max-width:335px}@media(min-width:768px){.main-header__icon.main-header__icon--small{display:none}}", ""]);
// Exports
module.exports = exports;
